import React, { Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate } from 'react-router-dom'
import { Container, Row, Col, Button } from 'reactstrap'

import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb'
import AddUpdateDictionary from '../../components/dictionary/AddUpdateDictionary'

const Dictionary = () => {
    const Navigate = useNavigate();

    return (
        <Fragment>
            <Breadcrumbs parent={t('breadcrumb.dictionary')} title={t('breadcrumb.dictionary')} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <AddUpdateDictionary />
                    </Col>
                </Row>
                <div className='d-flex flex-wrap justify-content-between mb-4'>
                    <Button color="danger" className="mt-2 me-2" onClick={() => Navigate('/dictionary')}>{t('back')}</Button>
                </div>
            </Container>
        </Fragment>
    )
}

export default Dictionary